import { FieldDefinition, FieldBuilder } from '@zendra/shared';
import { RegisterService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const INTERVENTIONSOIL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isForestPriority', 'Entity.InterventionSoil.IsForestPriority')
    .build(),
  FieldBuilder
    .number('soilArea', 'Entity.InterventionSoil.SoilArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('soilPercentage', 'Entity.InterventionSoil.SoilPercentage')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'registerId',
    'Entity.Register',
    RegisterService,
  )
    .required()
    .display('name')
    .displayFromNested('registerName')
    .sortBy('registerName')
    .keyField('id')
    .build(),
];

export const INTERVENTIONSOIL_CONFIG = {
  entityName: 'InterventionSoil',
  localizationKey: 'Geographic::Entity.InterventionSoil',
  fields: INTERVENTIONSOIL_FIELDS,
  permission: 'PlanningGeography.InterventionSoils',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
